import { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { Segment, SegmentGroup } from 'semantic-ui-react';
import { TitleSegment } from '@britishcouncil/react-admin';
import { useNavigationContext } from 'hooks';
import { TEST_CENTRE_OVERVIEW_QUERY_TAG, testCentreOverviewStore, useTypedDispatch } from 'store';
import { TestCentreOverviewTable } from './TestCentreOverviewTable';
import { TestCentreOverviewSummary } from './TestCentreOverviewSummary';
import {
  mapFiltersToQuery,
  getTestCentreOverviewFiltersInitialState,
  TestCentreOverviewFilterBar,
} from './TestCentreOverviewFilterBar';

export const TestCentreOverview = () => {
  const { centreName, locationId, locationName } = useNavigationContext();
  const dispatch = useTypedDispatch();

  const [selectedDistrictIds, setSelectedDistrictIds] = useState<number[]>(
    () => getTestCentreOverviewFiltersInitialState(locationId).district ?? []
  );
  const [appliedFilters, setAppliedFilters] = useState(() =>
    mapFiltersToQuery(getTestCentreOverviewFiltersInitialState(locationId), locationId)
  );

  const { data: districts } =
    testCentreOverviewStore.service.useGetTestCentreOverviewDistrictsQuery();
  const { data: venues } = testCentreOverviewStore.service.useGetTestCentreOverviewVenuesQuery({
    districtIds: selectedDistrictIds,
  });

  useEffect(() => {
    dispatch(
      testCentreOverviewStore.service.testCentreOverviewApi.util.invalidateTags([
        TEST_CENTRE_OVERVIEW_QUERY_TAG,
      ])
    );
  }, [dispatch]);

  return (
    <>
      <SegmentGroup>
        <TitleSegment title="Planned exams overview" subTitle={locationName ?? centreName} />
      </SegmentGroup>
      <SegmentGroup>
        <TestCentreOverviewFilterBar
          districts={
            locationId !== undefined && locationName !== undefined
              ? [{ id: locationId, name: locationName }]
              : (districts ?? [])
          }
          venues={venues ?? []}
          locationId={locationId}
          onFiltersChange={(values) => setSelectedDistrictIds(values.district ?? [])}
          onFiltersApply={(values) => setAppliedFilters(mapFiltersToQuery(values, locationId))}
          onFiltersClear={(values) => {
            setSelectedDistrictIds(values.district ?? []);
            setAppliedFilters(mapFiltersToQuery(values, locationId));
          }}
        />
      </SegmentGroup>
      <TestCentreOverviewSummary filters={appliedFilters} />
      <SegmentGroup>
        <TitleSegment title="Planned sessions" />
        <S.TableSegment attached="top">
          <TestCentreOverviewTable filters={appliedFilters} />
        </S.TableSegment>
      </SegmentGroup>
    </>
  );
};

const S = {
  TableSegment: styled(Segment)`
    padding: 0 !important;
    overflow: auto;
    max-height: 80vh;
  `,
};
